export var DataFlag = /*#__PURE__*/function (DataFlag) {
  // Moods
  DataFlag[DataFlag["MOOD_HAPPY"] = 1] = "MOOD_HAPPY";
  DataFlag[DataFlag["MOOD_CONFIDENT"] = 2] = "MOOD_CONFIDENT";
  DataFlag[DataFlag["MOOD_CALM"] = 3] = "MOOD_CALM";
  DataFlag[DataFlag["MOOD_ENERGETIC"] = 4] = "MOOD_ENERGETIC";
  DataFlag[DataFlag["MOOD_EXCITED"] = 5] = "MOOD_EXCITED";
  DataFlag[DataFlag["MOOD_PMS"] = 6] = "MOOD_PMS";
  DataFlag[DataFlag["MOOD_SWINGS"] = 7] = "MOOD_SWINGS";
  DataFlag[DataFlag["MOOD_IRRITABLE"] = 8] = "MOOD_IRRITABLE";
  DataFlag[DataFlag["MOOD_ANXIOUS"] = 9] = "MOOD_ANXIOUS";
  DataFlag[DataFlag["MOOD_STRESSED"] = 10] = "MOOD_STRESSED";
  DataFlag[DataFlag["MOOD_TIRED"] = 11] = "MOOD_TIRED";
  DataFlag[DataFlag["MOOD_SENSITIVE"] = 12] = "MOOD_SENSITIVE";
  DataFlag[DataFlag["MOOD_NUMB"] = 13] = "MOOD_NUMB";
  DataFlag[DataFlag["MOOD_SAD"] = 14] = "MOOD_SAD";
  DataFlag[DataFlag["MOOD_ANGRY"] = 15] = "MOOD_ANGRY";
  DataFlag[DataFlag["MOOD_FORGETFUL"] = 16] = "MOOD_FORGETFUL";
  // MOOD_NAUSEOUS = 17, moved to Pain
  DataFlag[DataFlag["MOOD_SICK"] = 18] = "MOOD_SICK";
  // MOOD_CRAVINGS = 19, moved to Pain
  DataFlag[DataFlag["MOOD_SENSITIVE_TO_SMELL"] = 20] = "MOOD_SENSITIVE_TO_SMELL";
  DataFlag[DataFlag["MOOD_EXHAUSTED"] = 21] = "MOOD_EXHAUSTED";
  DataFlag[DataFlag["MOOD_UNFOCUSED"] = 77] = "MOOD_UNFOCUSED";
  DataFlag[DataFlag["MOOD_SELF_CRITICAL"] = 78] = "MOOD_SELF_CRITICAL";
  DataFlag[DataFlag["MOOD_FEELING_GUILTY"] = 79] = "MOOD_FEELING_GUILTY";
  DataFlag[DataFlag["MOOD_OBSESSIVE_THOUGHTS"] = 80] = "MOOD_OBSESSIVE_THOUGHTS";
  DataFlag[DataFlag["MOOD_CONFUSED"] = 81] = "MOOD_CONFUSED";
  DataFlag[DataFlag["MOOD_ISOLATED"] = 89] = "MOOD_ISOLATED";
  DataFlag[DataFlag["MOOD_WITHDRAWN"] = 90] = "MOOD_WITHDRAWN";
  DataFlag[DataFlag["MOOD_SOCIABLE"] = 91] = "MOOD_SOCIABLE";
  DataFlag[DataFlag["MOOD_FEELING_LOW"] = 123] = "MOOD_FEELING_LOW";
  // Pain
  DataFlag[DataFlag["PAIN_CRAMPS"] = 22] = "PAIN_CRAMPS";
  DataFlag[DataFlag["PAIN_BACKACHE"] = 23] = "PAIN_BACKACHE";
  DataFlag[DataFlag["PAIN_SORE_BREASTS"] = 24] = "PAIN_SORE_BREASTS";
  DataFlag[DataFlag["PAIN_OVULATION"] = 25] = "PAIN_OVULATION";
  DataFlag[DataFlag["PAIN_HEADACHE"] = 26] = "PAIN_HEADACHE";
  DataFlag[DataFlag["PAIN_OTHER"] = 27] = "PAIN_OTHER";
  DataFlag[DataFlag["PAIN_HEARTBURN"] = 28] = "PAIN_HEARTBURN";
  DataFlag[DataFlag["PAIN_PELVIC"] = 29] = "PAIN_PELVIC";
  DataFlag[DataFlag["PAIN_SWELLING"] = 30] = "PAIN_SWELLING";
  DataFlag[DataFlag["PAIN_CONTRACTIONS"] = 45] = "PAIN_CONTRACTIONS";
  DataFlag[DataFlag["PAIN_NAUSEOUS"] = 17] = "PAIN_NAUSEOUS";
  DataFlag[DataFlag["PAIN_CRAVINGS"] = 19] = "PAIN_CRAVINGS";
  DataFlag[DataFlag["PAIN_DIARRHEA"] = 73] = "PAIN_DIARRHEA";
  DataFlag[DataFlag["PAIN_CONSTIPATION"] = 74] = "PAIN_CONSTIPATION";
  DataFlag[DataFlag["PAIN_BLOATING"] = 75] = "PAIN_BLOATING";
  DataFlag[DataFlag["PAIN_MOVEMENTS"] = 76] = "PAIN_MOVEMENTS";
  DataFlag[DataFlag["PAIN_SORE_NIPPLES"] = 84] = "PAIN_SORE_NIPPLES";
  DataFlag[DataFlag["PAIN_VAGINAL"] = 85] = "PAIN_VAGINAL";
  DataFlag[DataFlag["PAIN_STITCHES"] = 86] = "PAIN_STITCHES";
  DataFlag[DataFlag["PAIN_HEMORRHOIDS"] = 87] = "PAIN_HEMORRHOIDS";
  DataFlag[DataFlag["PAIN_HOT_FLASHES"] = 97] = "PAIN_HOT_FLASHES";
  DataFlag[DataFlag["PAIN_NIGHT_SWEATS"] = 98] = "PAIN_NIGHT_SWEATS";
  DataFlag[DataFlag["PAIN_HEART_PALPITATIONS"] = 99] = "PAIN_HEART_PALPITATIONS";
  DataFlag[DataFlag["PAIN_JOINT"] = 100] = "PAIN_JOINT";
  DataFlag[DataFlag["PAIN_MIGRAINE"] = 101] = "PAIN_MIGRAINE";
  DataFlag[DataFlag["PAIN_INSOMNIA"] = 102] = "PAIN_INSOMNIA";
  DataFlag[DataFlag["PAIN_FATIGUE"] = 103] = "PAIN_FATIGUE";
  DataFlag[DataFlag["PAIN_BRAIN_FOG"] = 104] = "PAIN_BRAIN_FOG";
  DataFlag[DataFlag["PAIN_FREQUENT_URINATION"] = 105] = "PAIN_FREQUENT_URINATION";
  DataFlag[DataFlag["PAIN_BLADDER_LEAKAGE"] = 106] = "PAIN_BLADDER_LEAKAGE";
  DataFlag[DataFlag["PAIN_VAGINAL_DRYNESS"] = 107] = "PAIN_VAGINAL_DRYNESS";
  // More
  DataFlag[DataFlag["MORE_EMERGENCY_PILL"] = 31] = "MORE_EMERGENCY_PILL";
  DataFlag[DataFlag["MORE_EMERGENCY_IUD"] = 32] = "MORE_EMERGENCY_IUD";
  // DeviationReason
  DataFlag[DataFlag["DEVIATION_REASON_OTHER"] = 40] = "DEVIATION_REASON_OTHER";
  DataFlag[DataFlag["DEVIATION_REASON_SLEEP"] = 41] = "DEVIATION_REASON_SLEEP";
  DataFlag[DataFlag["DEVIATION_REASON_ALCOHOL"] = 42] = "DEVIATION_REASON_ALCOHOL";
  DataFlag[DataFlag["DEVIATION_REASON_SICK"] = 43] = "DEVIATION_REASON_SICK";
  DataFlag[DataFlag["DEVIATION_REASON_ALGO"] = 44] = "DEVIATION_REASON_ALGO";
  // Covid
  DataFlag[DataFlag["COVID_DRY_COUGH"] = 46] = "COVID_DRY_COUGH";
  DataFlag[DataFlag["COVID_SHORT_BREATH"] = 47] = "COVID_SHORT_BREATH";
  DataFlag[DataFlag["COVID_FATIGUE"] = 48] = "COVID_FATIGUE";
  DataFlag[DataFlag["COVID_SORE_THROAT"] = 49] = "COVID_SORE_THROAT";
  DataFlag[DataFlag["COVID_DIARRHEA"] = 50] = "COVID_DIARRHEA";
  DataFlag[DataFlag["COVID_MUSCLE_PAIN"] = 51] = "COVID_MUSCLE_PAIN";
  DataFlag[DataFlag["COVID_HEADACHE"] = 52] = "COVID_HEADACHE";
  DataFlag[DataFlag["COVID_LOSS_TASTE_SMELL"] = 53] = "COVID_LOSS_TASTE_SMELL";
  // Oura flags generated by OuraAlgorithm
  DataFlag[DataFlag["OURA_ADJUSTED_TEMPERATURE"] = 54] = "OURA_ADJUSTED_TEMPERATURE";
  DataFlag[DataFlag["OURA_IRREGULAR_SLEEP"] = 55] = "OURA_IRREGULAR_SLEEP";
  DataFlag[DataFlag["OURA_INCOMPLETE_DATA"] = 56] = "OURA_INCOMPLETE_DATA";
  DataFlag[DataFlag["OURA_DEVIATION_ALGO"] = 72] = "OURA_DEVIATION_ALGO";
  DataFlag[DataFlag["OURA_SHORT_SLEEP"] = 88] = "OURA_SHORT_SLEEP";
  // Oura flags that are allowed to be saved by the User
  DataFlag[DataFlag["OURA_ALCOHOL"] = 57] = "OURA_ALCOHOL";
  DataFlag[DataFlag["OURA_SICK"] = 58] = "OURA_SICK";
  // Skin
  DataFlag[DataFlag["SKIN_DRY"] = 59] = "SKIN_DRY";
  DataFlag[DataFlag["SKIN_OILY"] = 60] = "SKIN_OILY";
  DataFlag[DataFlag["SKIN_PUFFY"] = 61] = "SKIN_PUFFY";
  DataFlag[DataFlag["SKIN_ACNE"] = 62] = "SKIN_ACNE";
  DataFlag[DataFlag["SKIN_GLOWING"] = 63] = "SKIN_GLOWING";
  DataFlag[DataFlag["SKIN_CHLOASMA"] = 64] = "SKIN_CHLOASMA";
  DataFlag[DataFlag["SKIN_OTHER"] = 65] = "SKIN_OTHER";
  DataFlag[DataFlag["SKIN_HAIR_LOSS"] = 82] = "SKIN_HAIR_LOSS";
  DataFlag[DataFlag["SKIN_STRETCH_MARKS"] = 83] = "SKIN_STRETCH_MARKS";
  // Sex
  DataFlag[DataFlag["SEX_MASTURBATION"] = 66] = "SEX_MASTURBATION";
  DataFlag[DataFlag["SEX_ORAL"] = 67] = "SEX_ORAL";
  DataFlag[DataFlag["SEX_TOUCHING"] = 68] = "SEX_TOUCHING";
  DataFlag[DataFlag["SEX_TOYS"] = 69] = "SEX_TOYS";
  DataFlag[DataFlag["SEX_ANAL"] = 70] = "SEX_ANAL";
  // Other
  DataFlag[DataFlag["ORIGINAL_PERIOD_PREDICTION"] = 71] = "ORIGINAL_PERIOD_PREDICTION";
  DataFlag[DataFlag["WEIGHT_GAIN"] = 124] = "WEIGHT_GAIN";
  DataFlag[DataFlag["LOWER_LIBIDO"] = 125] = "LOWER_LIBIDO";
  // Flags generated by TempExtractionAlgo
  DataFlag[DataFlag["TEMP_EXTRACTION_DISCARDED_DUE_TO_HOLES"] = 92] = "TEMP_EXTRACTION_DISCARDED_DUE_TO_HOLES";
  DataFlag[DataFlag["TEMP_EXTRACTION_DISCARDED_DUE_TO_FLAT_SPECTRUM"] = 93] = "TEMP_EXTRACTION_DISCARDED_DUE_TO_FLAT_SPECTRUM";
  DataFlag[DataFlag["TEMP_EXTRACTION_DISCARDED_DUE_TO_NO_STABLE_POINTS"] = 94] = "TEMP_EXTRACTION_DISCARDED_DUE_TO_NO_STABLE_POINTS";
  DataFlag[DataFlag["TEMP_EXTRACTION_INSUFFICIENT_SLEEP"] = 95] = "TEMP_EXTRACTION_INSUFFICIENT_SLEEP";
  DataFlag[DataFlag["TEMP_EXTRACTION_TEMP_CORRECTED"] = 96] = "TEMP_EXTRACTION_TEMP_CORRECTED";
  // Lifestyle
  DataFlag[DataFlag["LIFESTYLE_ALCOHOL"] = 108] = "LIFESTYLE_ALCOHOL";
  DataFlag[DataFlag["LIFESTYLE_CAFFEINE"] = 109] = "LIFESTYLE_CAFFEINE";
  DataFlag[DataFlag["LIFESTYLE_SUGAR"] = 110] = "LIFESTYLE_SUGAR";
  DataFlag[DataFlag["LIFESTYLE_HIGH_FAT_FOOD"] = 111] = "LIFESTYLE_HIGH_FAT_FOOD";
  DataFlag[DataFlag["LIFESTYLE_SMOKING"] = 112] = "LIFESTYLE_SMOKING";
  DataFlag[DataFlag["LIFESTYLE_STRESS"] = 113] = "LIFESTYLE_STRESS";
  DataFlag[DataFlag["LIFESTYLE_THERAPY"] = 114] = "LIFESTYLE_THERAPY";
  DataFlag[DataFlag["LIFESTYLE_JOURNALING"] = 115] = "LIFESTYLE_JOURNALING";
  DataFlag[DataFlag["LIFESTYLE_KEGEL_EXERCISE"] = 116] = "LIFESTYLE_KEGEL_EXERCISE";
  DataFlag[DataFlag["LIFESTYLE_BREATHING_EXERCISE"] = 117] = "LIFESTYLE_BREATHING_EXERCISE";
  DataFlag[DataFlag["LIFESTYLE_SUPPLEMENTS"] = 118] = "LIFESTYLE_SUPPLEMENTS";
  DataFlag[DataFlag["LIFESTYLE_MINDFULNESS"] = 119] = "LIFESTYLE_MINDFULNESS";
  // External factors
  DataFlag[DataFlag["EXTERNAL_FACTOR_WEATHER"] = 120] = "EXTERNAL_FACTOR_WEATHER";
  DataFlag[DataFlag["EXTERNAL_FACTOR_TRAVEL"] = 121] = "EXTERNAL_FACTOR_TRAVEL";
  DataFlag[DataFlag["EXTERNAL_FACTOR_FEELING_OFF"] = 122] = "EXTERNAL_FACTOR_FEELING_OFF";
  return DataFlag;
}(DataFlag || {});
export const OURA_FLAGS_ALGO_GENERATED = [DataFlag.OURA_ADJUSTED_TEMPERATURE, DataFlag.OURA_INCOMPLETE_DATA, DataFlag.OURA_IRREGULAR_SLEEP, DataFlag.OURA_SHORT_SLEEP, DataFlag.OURA_DEVIATION_ALGO];
export const OURA_FLAGS_ALGO_GENERATED_SET = new Set(OURA_FLAGS_ALGO_GENERATED);
export const DEVIATION_FLAGS_USER = [DataFlag.DEVIATION_REASON_SLEEP, DataFlag.DEVIATION_REASON_ALCOHOL, DataFlag.DEVIATION_REASON_SICK, DataFlag.DEVIATION_REASON_OTHER];
export const DEVIATION_FLAGS_USER_SET = new Set(DEVIATION_FLAGS_USER);
export const DEVIATION_FLAGS_ALGO = [DataFlag.DEVIATION_REASON_ALGO];
export const DEVIATION_FLAGS_ALGO_SET = new Set(DEVIATION_FLAGS_ALGO);
export const DEVIATION_FLAGS_ALL = [...DEVIATION_FLAGS_USER, ...DEVIATION_FLAGS_ALGO];
export const DEVIATION_FLAGS_ALL_SET = new Set(DEVIATION_FLAGS_ALL);